export default __webpack_public_path__ + "static/media/topbar.9416bd3a.png";